import { render, staticRenderFns } from "./FormPurchase.vue?vue&type=template&id=a1490428"
import script from "./FormPurchase.vue?vue&type=script&lang=js"
export * from "./FormPurchase.vue?vue&type=script&lang=js"
import style0 from "./FormPurchase.vue?vue&type=style&index=0&id=a1490428&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports